import { css } from '@emotion/react';
import Tooltip from '@tippyjs/react';
import { FC } from 'react';

import { Icon } from '../icon';

interface InputInfoIconShellProps {
  message?: string;
}

export const InputInfoIconShell: FC<InputInfoIconShellProps> = ({ message }) => {
  return (
    <Tooltip content={<span>{message}</span>} trigger="mouseenter focus click">
      <div css={styles.iconStyles}>
        <Icon type="questionmark" />
      </div>
    </Tooltip>
  );
};

const styles = {
  iconStyles: css({
    padding: 0,
    background: 'none',
    border: 'none',
  }),
};
